export * from "./WBSRow";
export * from "./ModelMap";
export * from "./Tabs";
export * from "./KeyCode";

// TIPO DO RELATÓRIO
export const enum EReportType {
  EAP = 0,
  RESOURCE = 1,
  FORMATING = 2,
  TAKEOFF = 3,
  EAP_ANALYTICAL = 4,
  GROUPED_RESOURCES_SYNTHETIC = 5,
  GROUPED_RESOURCES_ANALYTICAL = 6,
  CURVE_ABC_SYNTHETIC = 7,
  CURVE_ABC_ANALYTICAL = 8,
}



// WEBPACK FOOTER //
// ./src/common/enums/index.ts